import { Link } from '@mui/material';
import { getSessionVersionToken } from '@ui-framework/index';

export const LOGO_TYPE = {
  FULL: 'FULL',
  COMPACT: 'COMPACT',
};

function Logo({
  href = null,
  target = '',
  size = 'large',
  type = LOGO_TYPE.FULL,
  imgProps = {},
  ...props
}) {
  let width = type === LOGO_TYPE.FULL ? 250 : 75;

  if (type === LOGO_TYPE.FULL && size === 'medium') {
    width = 170;
  } else if (type === LOGO_TYPE.FULL && size === 'small') {
    width = 150;
  } else if (type === LOGO_TYPE.COMPACT && size === 'medium') {
    width = 40;
  } else if (type === LOGO_TYPE.COMPACT && size === 'small') {
    width = 20;
  }

  const sessionVersion = getSessionVersionToken();

  const Img = (
    <img
      width={width}
      alt="Logo"
      src={
        type === LOGO_TYPE.FULL
          ? `/logo.png?v=${sessionVersion}`
          : `/mobilelogo.png?v=${sessionVersion}`
      }
      {...imgProps}
    />
  );

  if (href) {
    return (
      <Link href={href} {...(target !== '' && { target })} {...props}>
        {Img}
      </Link>
    );
  }
  return Img;
}

export default Logo;
